import { useActions } from 'shared/hooks';
import { sendContactInfo } from 'api/surveys';
import { postPaymentInfo } from 'store/payment/actions';
import { putContactInfo } from 'store/survey/actions';
import { PaymentInfoFormData } from '../../../../api/payment/types';
import { SendContactData } from '../../../../api/surveys/types';
import * as React from 'react';
import { redirectToUrl } from '../../survey/PaymentClaim/helpers';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../rootReducer';
import {
  selectPaymentRedirectTo,
  selectPaymentAlertLevel,
  selectPaymentAlertMsg,
} from '../../../../store/payment/selectors';

export const usePaymentActions = () =>
  useActions({
    postPaymentInfo,
  });

export const useContactActions = () =>
  useActions({
    putContactInfo,
  });

export const usePaymentSelectors = () =>
  useSelector((state: RootState) => {
    return {
      redirect_to: selectPaymentRedirectTo(state),
      alert_level: selectPaymentAlertLevel(state),
      alert_msg: selectPaymentAlertMsg(state),
    };
  });

export const useHandleSubmit = () => {
  const { postPaymentInfo: postAction } = usePaymentActions();
  return async (
    formData: PaymentInfoFormData,
    showError: React.Dispatch<React.SetStateAction<boolean>>,
  ) => {
    try {
      await postAction(formData);
    } catch (e) {
      showError(true);
    }
  };
};

export const useRedirectToUrl = (paymentPendingUrl: string) => {
  const { alert_level } = usePaymentSelectors();
  React.useEffect(() => {
    if (alert_level === 'success') {
      redirectToUrl(paymentPendingUrl);
    }
  }, [alert_level]);
};

export const useContactInfoSubmit = () => {
  return async (
    data: SendContactData,
    showError: React.Dispatch<React.SetStateAction<boolean>>,
    redirectUrl: string,
    onPreferredEmailSyncFailed?: () => void,
  ) => {
    try {
      const result = await sendContactInfo(data);
      if (result.preferred_email_sync_failed) {
        onPreferredEmailSyncFailed?.();
        return;
      }
      localStorage.setItem('contact_email', data.email);
      redirectToUrl(redirectUrl);
    } catch (e) {
      showError(true);
    }
  };
};
